import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router';
import logo from 'media/logo.png';
import styles from './styles';
import Burguer from '../Burguer/index';
import { CartContext } from 'contexts/CartContext';
import SubtotalMenu from './SubtotalMenu';
import { useAlert } from 'react-alert'
import ShoppingIcon from 'components/ShoppingIcon';

const NavElements = ({ open, toggle }) => {
    const { cart, updateCart } = useContext(CartContext);
    const [subtotalShown, setSubtotalShown] = useState(false);
    const currentCartBalance = cart?.map(it => it.priceEUR).reduce((a, b) => a + b, 0) || 0;
    const alert = useAlert();

    const toggleSubtotal = () => {
        setTimeout(() => {
            setSubtotalShown(!subtotalShown);
        }, 100);
    }

    const clearCart = () => {
        updateCart([]);
        alert.show(`Cart cleared`, { type: 'info' });
    }

    return (
        <>
            <styles.LogoLink to="/">
                <styles.Logo src={logo} alt="Oracliom" />
            </styles.LogoLink>
            <styles.Nav >
                <Burguer toggle={toggle} open={open} />
                <styles.Menu>
                    <styles.LinkButton onClick={() => { window.open("https://calendly.com/luisenriquecgongora") }}> SCHEDULE A CONSULTATION </styles.LinkButton>
                    <styles.ContainerSubtotal>
                        <ShoppingIcon />
                        <styles.ContainerSubtotalAmount onClick={() => { !subtotalShown && toggleSubtotal(); }}><span>{currentCartBalance} €</span>  <styles.ArrowDownContainer open={subtotalShown} ><styles.ArrowDown /></styles.ArrowDownContainer></styles.ContainerSubtotalAmount>
                        {subtotalShown && <SubtotalMenu toggleSubtotal={toggleSubtotal} clearCart={clearCart} />}
                    </styles.ContainerSubtotal>
                    {/* <styles.Link to="/cart"> EUR </styles.Link> */}
                    {/* <styles.Link to="/cart"> EN </styles.Link> */}
                </styles.Menu>
            </styles.Nav>
        </>

    );
};

export default withRouter(NavElements);
